import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { HttpService } from "../http/http.service";
import { Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";

@Injectable()
export class ItemsService extends ApiService {
    constructor(protected http: HttpService) {
        super(http);
        this.url = 'api/marketplace/items/'
    }

    importItems(resource: any): Observable<any> {
        return this.http.post(this.url, resource);
    }
}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/anbe-dev/src/app/shared/services/api/items.service.ts